import { type BorderRadius, Colors, type TextAlignment } from "schemas";
import { LinkButton } from "../../components/LinkButton";

interface Props {
  label: string;
  url: string;
  neutered?: boolean;
  buttonTextColor: string;
  buttonBackgroundColor: string;
  buttonTextAlignment: TextAlignment;
  buttonBorderRadius: BorderRadius;
}

const FormIconLight = "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/4a7f66f7-8e62-4dbd-d57f-5372301baf00/logo";
const FormIconDark = "https://imagedelivery.net/Th3n8YNzYY9VHoBbIYD5Fw/d75e93a6-f403-4ae0-ccc0-4163c5350300/logo";

export function FormLinkBlock({
  label,
  url,
  neutered,
  buttonTextColor,
  buttonBackgroundColor,
  buttonBorderRadius,
  buttonTextAlignment,
}: Props) {
  const iconSrc = buttonTextColor === Colors.Neutral0 ? FormIconLight : FormIconDark;

  return (
    <LinkButton
      href={neutered ? "#" : url}
      iconSrc={iconSrc}
      buttonTextColor={buttonTextColor}
      buttonBackgroundColor={buttonBackgroundColor}
      buttonBorderRadius={buttonBorderRadius}
      buttonTextAlignment={buttonTextAlignment}
    >
      <div
        style={{
          display: "inline-block",
          width: buttonTextAlignment === "Center" ? "auto" : "90%",
        }}
      >
        {label}
      </div>
    </LinkButton>
  );
}
